import formatPageLinks from "./formatPageLinks";

const formatOnPageNavData = (page, locale, homepageSlug, currentSpaceId, products, siteIdentifier) => {
  const formattedData = page?.displayPageGroupNavigation === true && page?.onPageNavGroup ? {
    navItems: page?.onPageNavGroup?.navItems,
    navCta: formatPageLinks(page?.onPageNavGroup?.navCta, locale, page?.onPageNavGroup?.navCta?.url?.__typename, homepageSlug, currentSpaceId, products, siteIdentifier),
    navTitle: page?.onPageNavGroup?.navTitle
  } : {
    navItems: page?.onPageNavItems,
    navCta: formatPageLinks(page?.onPageNavCta, locale, page?.onPageNavCta?.url?.__typename, homepageSlug, currentSpaceId, products, siteIdentifier),
    navTitle: page?.onPageNavTitle
  };

  const formattedItems = formattedData?.navItems?.map((item) => {
    const formattedItem = formatPageLinks(item, locale, item?.url?.__typename, homepageSlug, currentSpaceId, products, siteIdentifier) != null 
      ? formatPageLinks(item, locale, item?.url?.__typename, homepageSlug, currentSpaceId, products, siteIdentifier) 
      : null;
    return formattedItem;
  });

  formattedData.navItems = formattedItems?.filter((item) => item != null);
  return formattedData;
}

export default formatOnPageNavData
